import { render, staticRenderFns } from "./WsFilterItem.vue?vue&type=template&id=1a9c112c"
import script from "./WsFilterItem.vue?vue&type=script&lang=js"
export * from "./WsFilterItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports